import React from 'react'
import { Money } from '../../../components/Money/Money.react'
import { Active, Paused } from './StatusIndicators.react'
import * as styles from './BalanceSections.styles'
import countryDate from '../../../core/main/filter/country_date/filter'
import Authentication from '../../../main/factory/authentication'
import '../../i18next.react'
import { useTranslation } from 'react-i18next'

const NoWrapMoney = (props) => (
  <span className={styles.money}>
    <Money {...props} explicit />
  </span>
)

export const Actions = ({ onViewTaxInvoice, onViewSettlementReport, onViewActivityReport, reservesEnabled }) => {
  const { t } = useTranslation('settlements')
  const country = Authentication.countryCode().toUpperCase()
  const showInvoices = country !== 'FR' && country !== 'IT'
  return (
    <div className={styles.section} data-testid='merchant-balance-summary__actions-section'>
      {showInvoices &&
        <div className={styles.buttonContainer}>
          <button onClick={onViewTaxInvoice} className='button button-round'>{t('tax-invoice')}</button>
        </div>}
      <div className={styles.buttonContainer}>
        <button onClick={onViewSettlementReport} className='button button-round'>{t('settlement-report')}</button>
      </div>
      {reservesEnabled &&
        <div className={styles.buttonContainer}>
          <button onClick={onViewActivityReport} className='button button-round'> {t('reserves-activity-report')}</button>
        </div>}
    </div>
  )
}

export const SettlementSummary = ({ pausedStatus }) => {
  const { t } = useTranslation('settlements')
  const { paused, pausedAt } = pausedStatus
  const countryCode = Authentication.countryCode()

  return (
    <div className={styles.section} data-testid='merchant-balance-summary__settlement-section'>
      <div className={styles.headerRow}>
        <div className={styles.bold} data-testid='merchant-balance-summary__settlements-message'>{t('settlements')}</div>
        {paused ? <Paused /> : <Active />}
      </div>
      {!paused && <p data-testid='merchant-balance-summary__settling-message'>{t('currently-settling')}</p>}
      {paused &&
        <p data-testid='merchant-balance-summary__paused-message'>
          {t('settlements-paused-from')} {countryDate(pausedAt, { countryCode, includeTime: true })}
        </p>}
    </div>
  )
}

const ReservesActive = ({ currentReservesAmount, rollingReservesAmount }) => {
  const { t } = useTranslation('settlements')
  return (
    <div className={styles.section} data-testid='merchant-balance-summary__reserves-section'>
      <div className={styles.headerRow}>
        <div className={styles.bold}>{t('reserves')}</div>
        <Active />
      </div>

      <div className={styles.spaceBetween} data-testid='merchant-balance-summary__reserves-section__current'>
        <div>{t('current')}</div>
        <NoWrapMoney amount={currentReservesAmount.amount} currency={currentReservesAmount.currency} />
      </div>
      <div className={styles.spaceBetween} data-testid='merchant-balance-summary__reserves-section__rolling'>
        <div>{t('rolling')}</div>
        <NoWrapMoney amount={rollingReservesAmount.amount} currency={rollingReservesAmount.currency} />
      </div>
    </div>
  )
}

export const ReservesSummary = ({ enabled, currentReservesAmount, rollingReservesAmount }) => {
  if (enabled) {
    return (
      <ReservesActive
        currentReservesAmount={currentReservesAmount}
        rollingReservesAmount={rollingReservesAmount}
      />
    )
  }

  return <div className={styles.emptySpace} />
}
